var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4 20.6 4.75 16.6A8 8 0 1 1 7.9 19.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 8.4c-.3 0-.6.1-.85.4-.3.3-.9.9-.9 2.1s.92 2.45 1.05 2.6c.13.2 1.78 2.85 4.4 3.9 2.2.85 2.65.7 3.15.65.5-.05 1.55-.65 1.77-1.25.22-.6.22-1.15.15-1.25-.07-.1-.27-.15-.52-.3-.25-.15-1.55-.75-1.8-.85-.25-.1-.4-.15-.6.15-.2.3-.65.85-.8 1-.15.15-.3.2-.55.05-.25-.15-1.05-.4-2-1.25-.75-.65-1.25-1.5-1.4-1.75-.15-.25 0-.4.1-.5.1-.1.25-.3.4-.45.13-.15.17-.25.27-.45.1-.2.05-.35 0-.5-.05-.15-.55-1.4-.77-1.9-.2-.45-.4-.4-.55-.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.70309a0293c688d273ced94581dd9891.svg";
export { ForwardRef as ReactComponent };